<template>
  <div>
    <div>
     
       <!-- <tree-select-sec
        v-if="orgBack&&orgId!=1"
         @reset="orgName=''"
        @treeAll="getOrgValue"
        :disabled="false"
        style="
          width: 200px;
          display: inline-block;
          verticalAlign: bottom;
          fontsize: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select-sec> -->
       <el-date-picker
       value-format="yyyy-MM"
      v-model="startMonth"
      type="month"
      placeholder="选择开始日期"
       >
    </el-date-picker>
     <el-date-picker
      value-format="yyyy-MM"
      v-model="endMonth"
      type="month"
      placeholder="选择结束日期">
    </el-date-picker>
     <!-- <tree-select
        v-if="orgBack&&orgId==1"
        @treeAll="getOrgValue"
        @reset="search=''"
        :disabled="false"
        style="
             width: 250px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select> -->
       <el-input  clearable style="width:200px" placeholder="输入查找信息" v-model="search"></el-input>
      <el-button  @click="load">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list" border >
        <el-table-column align="center" label="医院名称" prop="hospitalName">
          <!-- <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>所属医院: {{ scope.row.orgName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.orgName }}</el-tag>
              </div>
            </el-popover>
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="日期">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.logDate }}</span>
          </template>
        </el-table-column>
         <el-table-column align="center" label="登录数" prop="loginNum">
        </el-table-column>
           <el-table-column align="center" label="检索数" prop="retrievalNum">
        </el-table-column>
          <el-table-column align="center" label="高级检索数" prop="seniorRetrievalNum">
        </el-table-column>
           <el-table-column align="center" label="下单数" prop="orderNum">
        </el-table-column>
         <el-table-column align="center" label="预览数" prop="previewNum">
        </el-table-column>
      <el-table-column align="center" label="合计" prop="tot">
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
     <!-- <el-divider v-if="openFlag"></el-divider>
     <div v-if="openFlag">
       <label >基数：</label><el-input clearable style="width:200px" placeholder="请输入基数" v-model="base"></el-input>
         <label style="marginLeft:20px">系数：</label>  <el-input clearable style="width:200px" placeholder="请输入系数数" v-model="coefficient"></el-input>
     </div>
    <el-dialog
      title="查看统计图"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div>
        <el-select v-model="typeValue" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <span>内容开发。。。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import treeSelectSec from "./treeSelect1";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
    treeSelectSec
  },
  created(){
    this.orgId=sessionStorage.getItem('orgId')
    this.openFlag = sessionStorage.getItem("admin") == 'admin' ? true : false
  },
  mounted() {
    this.load();
    this.getOrgList()
  },
  data() {
    return {
      search:'',
      startMonth:'',
      endMonth:'',
      orgId:'',
      orgBack:false,
      orgOption:[],
      intyear:'',
      base:0,//基数
      coefficient:1,//系数
      dialogVisible: false,
      orgName: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      typeList: [],
      typeValue: "",
      openFlag:false
    };
  },
  methods: {
    getOrgValue(x){
      this.search=x.id
    },
    getOrgList(){
       this.orgBack = false
       this.$api.structureChildrenList().then((res) => {
      console.log(res)
      if (res.data.code == 200) {
        this.orgBack = true;

        this.orgOption = res.data.data;
      }
    });
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.search,
        // intyear:this.intyear
        startMonth:this.startMonth,
        endMonth:this.endMonth,
      };
        if (obj.search) {
        obj.pageNo = 1;
      } else {
        obj.pageNo = this.page;
      }
      console.log(obj);
      this.$api.foreignDataState(obj).then((res) => {
        
        if (res.data.code == 200) {
          res.data.data.records.forEach(ele => {
              ele.tot = ele.loginNum + ele.orderNum + ele.previewNum + ele.retrievalNum + ele.seniorRetrievalNum
          });
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
        // console.log(this.list);
      });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
       let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.search,
        // intyear:this.intyear
        startMonth:this.startMonth,
        endMonth:this.endMonth,
      };
      
      console.log(obj);
      this.$api.foreignDataState(obj).then((res) => {
        
        if (res.data.code == 200) {
          res.data.data.records.forEach(ele => {
              ele.tot = ele.loginNum + ele.orderNum + ele.previewNum + ele.retrievalNum + ele.seniorRetrievalNum
          });
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
       
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .vue-treeselect--single .vue-treeselect__input{
  height: 37px;
}
</style>